import React from "react";
import data from "../../Data/Data";
import Btn from "../../ReUseAbleComp/Button.jsx";
import Header from "../../ReUseAbleComp/Header.jsx";
import Search from "../../ReUseAbleComp/SearchInput.jsx";
import { Helmet } from "react-helmet";
function LGEnglish({
  searchTagPashto,
  searchTerm,
  setSearchTerm,
  setPashtoSearch,
  PashtoSearch,
  handleChange,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Helmet>
        <title>محلي حکومت</title>
      </Helmet>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>محلي حکومت</h1>

        <Search
          handleChange={handleChange}
          searchTerm={searchTerm}
          searchTagPashto={searchTagPashto}
          dir="rtl"
        />

        {PashtoSearch.map((item) => (
          <Btn
            key={item.id}
            bool={true}
            title={item.Ptitle}
            id={item.RID}
            path={`/LGUrduDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
